import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;

// Build-time prerender (scripts/prerender-pages.ts) may inject static SEO
// content into #root so crawlers see unique title/H1/body/JSON-LD on first
// byte. Clear that content before mounting the SPA so React's createRoot
// renders into an empty container (no hydration mismatch).
if (container.firstChild) {
  container.innerHTML = "";
}

createRoot(container).render(<App />);
